import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  ICreatePerfilResponse,
  IDeletePerfilResponse,
  IGetPerfisResponse,
  IUpdatePerfilResponse
} from './perfil.model';

@Injectable({
  providedIn: 'root'
})
export class PerfilService {
  constructor(private http: HttpClient) {}

  public CreatePerfil(NM_PERF: string, guid: string): Observable<ICreatePerfilResponse> {
    const headers = new HttpHeaders({
          IdempotencyKey: guid
        });
        
    return this.http.post<any>(`${environment.baseURL}Perfil/CreatePerfil`, 
      { NM_PERF },
      { headers: headers });
  }

  public GetPerfis(): Observable<IGetPerfisResponse[]> {
    return this.http.get<any>(`${environment.baseURL}Perfil/GetPerfis`);
  }

  public UpdatePerfil(
    id: number,
    NM_PERF: string
  ): Observable<IUpdatePerfilResponse> {
    return this.http.put<any>(
      `${environment.baseURL}Perfil/UpdatePerfil?id=${id}`,
      {
        NM_PERF
      }
    );
  }

  public DeletePerfil(PK_PERF: number): Observable<IDeletePerfilResponse> {
    return this.http.delete<any>(
      `${environment.baseURL}Perfil/DeletePerfil?PK_PERF=${PK_PERF}`
    );
  }
}
